<template>
  <span v-text="text" />
</template>

<script>
import { Interval } from '@/models/Report/IntervalReport'
const intervalItems = [
  { value: Interval.TOTAL, text: '全期間' },
  { value: Interval.DAILY, text: '日ごと' },
  { value: Interval.MONTHLY, text: '月ごと' },
  { value: Interval.INSERTION_ORDER_BUDGET, text: '案件予算期間ごと' },
]

export default {
  name: 'IntervalReportListInterval',
  props: {
    value: {
      type: String,
      default: '',
      validator(value) {
        return Object.values(Interval).includes(value)
      },
    },
  },
  computed: {
    text() {
      return intervalItems.find(item => item.value === this.value).text
    },
  },
}
</script>
